import React, { Fragment } from 'react';
import { ArcaField } from '../../../code/ArcaField';
import { ArcaHttpClientPageDetails } from '../../../code/ArcaHttpClientPageDetails';
import { ArcaPageFieldState } from '../../../code/ArcaPageFieldState';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { InputField } from '../Fields/InputField';
import { StatusBar } from '../StatusBar';

export class PageEditPanel extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            statusText: null,
            isError: false,
            formState: this.buildFields(this.props.details),
            details: this.props.details
        };
    }

    render() {
        let { isError, statusText } = this.state
        return (
            <Fragment>
                <ArcaLink
                    onClick={this.onSubmit.bind(this)}
                    width='100%'
                    disabled={!this.state.formValid} text='Save' />

                <StatusBar isError={isError} message={statusText} />
                <br />
                {this.state.formState.Fields.map((f, k) =>
                    <InputField
                        key={k}
                        label={f.FieldLabel}
                        fieldname={f.FieldName}
                        regularExpression={f.Validation}
                        warnText='Invalid format'
                        mandatory={f.IsMandatory}
                        value={f.Value}
                        fieldType={f.FieldType}
                        onUpdate={this.onUpdate.bind(this)}
                        fieldValid={f.IsValid}
                        description={f.Description}
                    />

                )}

            </Fragment>);
    }

    async onSubmit() {
        await ArcaHttpClientPageDetails.SaveAsync(
            this.state.details,
            (() => this.props.onSaved(this.state.details)),
            ((msg) => this.setState({ isError: true, statusText: msg }))
        )

    }

    onUpdate(value, isValid, fieldName) {

        this.state.formState.GetField(fieldName).Value = value;

        let { details } = this.state;
        details[fieldName] = value;

        this.setState({
            details,
            formState: this.state.formState,
            disabled: false,
            formValid: this.state.formState.IsValid,
        });
    }

    buildFields(details) {
        var formState = new ArcaPageFieldState();
        formState.AddField(new ArcaField("Group", "GroupName", details.GroupName, true, true, 'text', 'freeform'));
        formState.AddField(new ArcaField("Title", "Title", details.Title, true, true, 'text', 'boolean'));
        formState.AddField(new ArcaField("Order on page", "OrderBy", details.OrderBy, true, true, 'integer', 'integer'));
        formState.AddField(new ArcaField("Preamble", "Preamble", details.Preamble, true, false, 'text', 'freeform'));
        formState.AddField(new ArcaField("Tagline", "Tagline", details.Tagline, true, false, 'text', 'freeform'));
        formState.AddField(new ArcaField("Description", "Description", details.Description, true, true, 'textarea', 'freeform', 'Use /n for a new paragraph'));
        formState.AddField(new ArcaField("Photo", "Photo", details.Photo, true, true, 'photo', 'photo'));
        formState.AddField(new ArcaField("Position", "PhotoPosition", details.PhotoPosition, true, true, 'select', 'positionType'));

        return formState;
    }
}